require('./bootstrap');
require('./bootstrap-datepicker.min');

// show related facilities nav drop-down
(function () {
    let loaded = false;

    function renderUtility(utility) {
        const facilities = utility.facilities.map(f => `
            <a href="/facility/${f.id}/flow/start/1/0" class="dropdown-item d-flex">
                <i class="fa fa-${f.survey_year_status.user_editable ? 'edit mr-1' : 'lock mr-2'} my-auto"></i>
                ${f.name}
                <small class="d-block ml-auto my-auto pl-5">${f.survey_year.name}</small>
            </a>
        `);

        return `
            <div class="dropdown-divider"></div>
            <div class="dropdown-item disabled">
                <small>${utility.name}</small>
            </div>
            ${facilities.join('')}
        `;
    }

    $('#nav-facility-picker-root').on('show.bs.dropdown', function () {
        if (!loaded) {
            window.fetch(`/api/facility/${$(this).attr('data-facility-id')}/related`)
                .then(resp => {
                    if (resp.ok) {
                        return resp.json();
                    } else {
                        throw new Error('Invalid response');
                    }
                })
                .then(json => {
                    $('#nav-facility-picker-items').html(`
                        <a href="/facility/${$(this).attr('data-facility-id')}/assembly" class="dropdown-item">
                            <i class="fa fa-search mr-1"></i>
                            Assembly Search
                        </a>
                        ${json.map(utility => renderUtility(utility)).join('')}
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="/facility">
                            <i class="fa fa-building mr-1"></i>
                            All Facilities...
                        </a>
                    `);

                    loaded = true;
                })
                .catch(err => {
                    window.console && window.console.error && window.console.error(err);
                    $('#nav-facility-picker-items').html(`
                        <div class="dropdown-item disabled">
                            There was a problem loading facilities.
                        </div>
                    `);
                })
        }
    })
})();
